var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("footer", { staticClass: "ft-content space-up" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12 footer-text" }, [
            _c("span", { staticClass: "text-red" }, [
              _vm._v(
                "การทำรายการหลังเวลา 15.00 น. ถือว่าเป็นการทำรายการของวันทำการถัดไป"
              )
            ])
          ]),
          _c("div", { staticClass: "col-12 contact" }, [
            _c("i", { staticClass: "feather-icon icon-phone" }),
            _c("span", [_vm._v("02-111-1111, 02-111-9999")]),
            _c("div", { staticClass: "vertical-line" }),
            _c("span", [_vm._v("KTB Call Center")])
          ])
        ]),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12 footer-text" }, [
            _c("p", { staticClass: "long-paragraph" }, [
              _vm._v(
                "เว็บไซต์นี้แสดงผลได้ดีบนเบราเซอร์ Chome Firefox Safari และ Internet Explorer เวอร์ชั่น 11 ขึ้นไป"
              )
            ]),
            _c("p", { staticClass: "long-paragraph" }, [
              _vm._v("สงวนสิทธิ์ พ.ศ. 2561 บมจ. ธนาคารกรุงไทย")
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }